import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function DevocionalArchive() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/devotionals")
      .then(({ data }) => setList(data))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="devotional-archive-page" className="bg-[#FAFAFA] min-h-screen">
      <Navbar />
      <main className="pt-28 pb-24">
        <div className="max-w-4xl mx-auto px-6 md:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#111827]/70 hover:text-[#C5A059] transition-colors duration-300"
          >
            <ArrowLeft size={14} strokeWidth={1.5} />
            Voltar ao início
          </Link>

          <div className="mt-10">
            <p className="text-[0.72rem] uppercase tracking-[0.3em] text-[#C5A059]">
              Arquivo · Devocional Diário
            </p>
            <h1 className="mt-4 font-serif-display text-[2.75rem] sm:text-5xl md:text-6xl lg:text-[5rem] text-[#0B1E36] leading-[1.0] tracking-[-0.032em] font-medium">
              Todas as reflexões.
            </h1>
          </div>

          <ul className="mt-14 divide-y divide-[#0B1E36]/10 border-t border-[#0B1E36]/10">
            {loading &&
              Array.from({ length: 3 }).map((_, i) => (
                <li key={i} className="py-10 animate-pulse">
                  <div className="h-6 bg-[#E5E7EB] w-1/2" />
                </li>
              ))}
            {!loading &&
              list.map((d) => (
                <li key={d.id}>
                  <Link
                    to={`/devocional/${d.id}`}
                    data-testid={`archive-row-${d.id}`}
                    className="group grid grid-cols-12 gap-6 items-baseline py-8 hover:bg-white px-2 transition-colors duration-300"
                  >
                    <span className="col-span-12 md:col-span-2 text-xs uppercase tracking-[0.22em] text-[#C5A059]">
                      {d.verse_reference}
                    </span>
                    <div className="col-span-12 md:col-span-8">
                      <h3 className="font-serif-display text-2xl md:text-3xl text-[#0B1E36] leading-tight">
                        {d.title}
                      </h3>
                      <p className="mt-2 text-sm text-[#111827]/65 italic">
                        "{d.impact_phrase}"
                      </p>
                    </div>
                    <div className="col-span-12 md:col-span-2 md:text-right">
                      <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#0B1E36] group-hover:text-[#C5A059] transition-colors duration-300">
                        Ler
                        <ArrowUpRight size={14} strokeWidth={1.5} />
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}
